import { GET, POST, download, uploading, POSTFormData, EXPORT, POSTNEW, EXPORTNEW,POSTFormDataNEW } from '@/request/http'
// 分页查询打卡记录
export const getAttendanceClockRecord = p => GET('/attendance/attendanceRecord', p)
// 获取全部考勤组
export const getAttendanceGroupList = p => GET('/attendance/attendanceGroup/list', p)
// 分页查询每日统计
export const getAttendanceDailyStats = p => GET('/attendance/dailyStats', p)
// 导出每日统计
export const exportAttendanceDailyStats = p => EXPORT('/attendance/dailyStats/export', p, 1, 'get')

// 分页查询月度统计
export const getAttendanceMonthlyStats = p => GET('/attendance/monthlyStats', p)
// 导出月度报表
export const exportAttendanceMonthlyStats = p => EXPORT('/attendance/monthlyStats/export', p, 1, 'get')
// 查询学生打卡记录
export const getAttendancePunchRecord = p => POSTNEW('/studentv2/attendanceRecord/page', p)

// 打卡记录统计
export const getClockRecordStatic = p => POSTNEW('/studentv2/attendanceRecord/studentRecordCount', p)

// 导出
export const clockREcordExport = p => EXPORTNEW('/studentv2/attendanceRecord/record/export', p)

// 导入
export const importClockList = p => POSTFormDataNEW('/studentv2/attendanceRecord/importNameList', p)

// 查询导入的数据
export const getImportClockList = p => POSTNEW('/studentv2/attendanceRecord/findPage', p)

// 添加打卡学生
export const addClockStudent = p => POSTNEW('/studentv2/attendanceRecord/saveUserRecord', p)

export const queryClockRecordStudent = p => POST('/attendance/studentDetailView/page', p, 1)

// 删除打卡学生
export const delClockStudent = p => POSTNEW('/studentv2/attendanceRecord/deleteRecord', p)

// 导出返校打卡数据
export const exportReturnClock = p => POSTNEW('/dataform/answer/exportRecord', p)

//查询无需打卡记录
export const queryNoRecordData = p => POSTNEW('/attendance/attendanceNoRecord/getNoRecodList', p)

//设置打卡
export const changeStatusRecord = p => POSTNEW('/attendance/attendanceNoRecord/saveRecord', p, 1)

//无需打卡
export const changeStatusNoRecord = p => POSTNEW('/attendance/attendanceNoRecord/saveNoRecord', p, 1)

//查辅导员
export const querybyfdy = p => POST('/counselor/counselor-info/findList/groupbyfaculty', p, 1)


// WEBPACK FOOTER //
// ./src/api/modules/attendance.js